function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable class-methods-use-this */
import GridModel from "./GridModel.js";
/**
 * A simple model that displays a viewport of data
 */
class ViewportDataGridModel extends GridModel {
  /**
   * Model for fetching data asynchonously. Set the viewported data when data is fetched.
   * @param columnCount Number of columns
   * @param rowCount Number of rows
   */
  constructor(columnCount, rowCount) {
    super();
    _defineProperty(this, "numberOfColumns", void 0);
    _defineProperty(this, "numberOfRows", void 0);
    _defineProperty(this, "viewportData", void 0);
    this.numberOfColumns = columnCount;
    this.numberOfRows = rowCount;
  }
  get columnCount() {
    return this.numberOfColumns;
  }
  get rowCount() {
    return this.numberOfRows;
  }
  textForCell(column, row) {
    var _this$viewportData$ro, _this$viewportData, _this$viewportData$co, _this$viewportData2, _this$viewportData$da, _this$viewportData3;
    var viewportRow = row - ((_this$viewportData$ro = (_this$viewportData = this.viewportData) === null || _this$viewportData === void 0 ? void 0 : _this$viewportData.rowOffset) !== null && _this$viewportData$ro !== void 0 ? _this$viewportData$ro : 0);
    var viewportColumn = column - ((_this$viewportData$co = (_this$viewportData2 = this.viewportData) === null || _this$viewportData2 === void 0 ? void 0 : _this$viewportData2.columnOffset) !== null && _this$viewportData$co !== void 0 ? _this$viewportData$co : 0);
    return "".concat((_this$viewportData$da = (_this$viewportData3 = this.viewportData) === null || _this$viewportData3 === void 0 || (_this$viewportData3 = _this$viewportData3.data[viewportRow]) === null || _this$viewportData3 === void 0 ? void 0 : _this$viewportData3[viewportColumn]) !== null && _this$viewportData$da !== void 0 ? _this$viewportData$da : '');
  }
  textForColumnHeader(column) {
    return "".concat(column);
  }
  textForRowHeader(row) {
    return "".concat(row);
  }
}
export default ViewportDataGridModel;
//# sourceMappingURL=ViewportDataGridModel.js.map